const privileges = [
  'admin',
  'manager',
  'operator',
  'supervisor',
  // 'user',
];

// Privilege domain definitions for the slider UI.
// Each domain has escalating levels (each step is a superset of the previous)
// and optional standalone toggles.
//
export const privilegeDomains = [
  {
    domain: 'reports',
    labelKey: 'reports',
    levels: [
      { code: null, labelKey: 'none' },
      { code: 'reportsSynopsis', labelKey: 'reportsSynopsis' },
      { code: 'reportsDetails', labelKey: 'reportsDetails' },
      { code: 'reportsHandle', labelKey: 'reportsHandle' },
      { code: 'reportsTalkToUsers', labelKey: 'reportsTalkToUsers' },
    ],
    toggles: [
      { code: 'reportsStats', labelKey: 'reportsStats' },
    ],
  },
  {
    domain: 'qr',
    labelKey: 'qr',
    levels: [
      { code: null, labelKey: 'none' },
      { code: 'qrView', labelKey: 'qrView' },
      { code: 'qrManage', labelKey: 'qrManage' },
      { code: 'qrEdit', labelKey: 'qrEdit' },
    ],
    toggles: [],
  },
  {
    domain: 'polls',
    labelKey: 'polls',
    levels: [
      { code: null, labelKey: 'none' },
      { code: 'pollViewResults', labelKey: 'pollViewResults' },
      { code: 'pollManage', labelKey: 'pollManage' },
      { code: 'pollEdit', labelKey: 'pollEdit' },
    ],
    toggles: [
      { code: 'pollViewContacts', labelKey: 'pollViewContacts' },
    ],
  },
  {
    domain: 'info',
    labelKey: 'info',
    levels: [
      { code: null, labelKey: 'none' },
      { code: 'infoView', labelKey: 'infoView' },
      { code: 'infoManage', labelKey: 'infoManage' },
      { code: 'infoEdit', labelKey: 'infoEdit' },
    ],
    toggles: [],
  },
  {
    domain: 'partners',
    labelKey: 'partners',
    levels: [
      { code: null, labelKey: 'none' },
      { code: 'partnerView', labelKey: 'partnerView' },
      { code: 'partnerEdit', labelKey: 'partnerEdit' },
    ],
    toggles: [],
  },
  {
    domain: 'branding',
    labelKey: 'branding',
    levels: [
      { code: null, labelKey: 'none' },
      { code: 'brandEdit', labelKey: 'brandEdit' },
    ],
    toggles: [],
  },
];

// Convert a flat privileges array to domain slider positions and toggles
//
export const privilegesToDomainState = (privArray) => {
  const state = {};
  privilegeDomains.forEach((domain) => {
    // Find the highest granted level
    let highestIndex = 0;
    domain.levels.forEach((level, index) => {
      if (level.code && privArray.includes(level.code)) {
        highestIndex = index;
      }
    });
    state[domain.domain] = {
      levelIndex: highestIndex,
      toggles: {},
    };
    domain.toggles.forEach((toggle) => {
      state[domain.domain].toggles[toggle.code] = privArray.includes(toggle.code);
    });
  });
  return state;
};

// Convert domain state back to a flat privileges array
// (only stores the highest level per domain, not implied ones)
//
export const domainStateToPrivileges = (domainState) => {
  const privArray = [];
  privilegeDomains.forEach((domain) => {
    const ds = domainState[domain.domain];
    if (!ds) return;
    const level = domain.levels[ds.levelIndex];
    if (level?.code) privArray.push(level.code);
    domain.toggles.forEach((toggle) => {
      if (ds.toggles[toggle.code]) privArray.push(toggle.code);
    });
  });
  return privArray;
};

// Pictograms per domain slider and per toggle
export const privilegesPictos = {
  reports: '/images/svg/gui/marker.svg',
  qr: '/images/svg/gui/qrFolders.svg',
  polls: '/images/svg/gui/vote.svg',
  info: '/images/svg/gui/info.svg',
  branding: '/images/svg/gui/branding.svg',
  reportsStats: '/images/svg/gui/statistics.svg',
  partners: '/images/svg/gui/handshake.svg',
  pollViewContacts: '/images/svg/gui/at.svg',
  qrFolders: '/images/svg/gui/qrFolders.svg',
};

export default privileges;
